<template>
  <el-button :class="['help-btn', { show: isHidden }]" id="helpButton" type="warning"  @click="openTour = true"
             style="position: absolute; top: 1rem; left: 0.6rem; height: 1rem; width: 5.3rem; z-index: 2001; font-size: 0.5rem" round>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 18 18" style="width: 0.6rem; height: 0.6rem; fill: white; margin-right: 8px">
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
    </svg>
    Help
  </el-button>

  <el-button id="hidden-btn" :class="['hidden-handler',  { show: isHidden }]" @mouseenter="isHover = true"
             @mouseleave="isHover = false"  @click="isHidden = !isHidden">
    <el-icon ref="handler" :style="{color: isHover ? '#a2a6d0' : '#333a5e'}" style="width: 0.93rem; height: 0.93rem" :size="28">
      <component :is="isHidden ? Hide : View"/>
    </el-icon>
  </el-button>

  <!-- Video Button and Dialog -->
  <AboutDialog :is-hidden="isHidden"/>

  <!-- 搜索框 -->
  <SearchDialog :is-hidden="isHidden"/>

  <!-- 左侧工具栏 -->
  <GraphTools :is-hidden="isHidden"/>

  <!-- 右侧图例 -->
  <LegendPanel ref="legendPanel" :is-hidden="isHidden"/>

  <el-tour type="primary" :target-area-clickable="false" :mask="{
      style: {
        boxShadow: 'inset 0 0 15px #333',
      },
      color: 'rgba(21, 21, 21, .01)',
    }" v-model="openTour">
    <el-tour-step
        :mask="true"
        title="Welcome to Network">
      <template #default>
        <div>
          NETWORK analyzes co-occurrence patterns between clinical and biological features derived from large-scale EHR and omics datasets.<br/>
          On-Node Left Click: Expand the child node of current node.<br/>
          On-Node Right Click: Navigate to Shiny app page.
        </div>
      </template>
    </el-tour-step>
    <el-tour-step
        placement="left"
        target="#hidden-btn"
        title="Hidden Button"
        description="Use the button to hide the layout and focus on the graph."
    />
    <el-tour-step
        placement="left"
        target="#btn-panel"
        title="Quick-Select Button"
        description="Use these buttons to select/remove entity quickly."
    />
    <el-tour-step
        placement="left"
        target="#legend-container-three"
        title="Selective Legend Panel"
        description="Use the panel to select/remove categories in the network graph."
    />
    <el-tour-step
        placement="left"
        target="#static-legend-panel"
        title="Legend for Node"
        description="The static legend menu here shows you the relationship between parent & child."
    />
    <el-tour-step
        placement="right"
        target="#graph-fixer"
        title="Viewport Tools"
        description="Use these buttons to fix in/fix out/adjust the viewport of the whole graph."
    />
    <el-tour-step
        placement="bottom"
        target="#opacity-slider"
        title="Edge-Opacity Modifier"
        description="You can justify the opacity of the edges in the graph if there are too many nodes present."
    />
    <el-tour-step
        placement="right"
        target="#searchButton"
        title="Search Dialog"
        description="Click here to open the search dialog which allow you to dynamically search nodes and apply the graph."
    />
    <el-tour-step
        placement="right"
        target="#aboutButton"
        title="About information"
        description="Click here to learn more about the network."
    />
    <el-tour-step
        placement="right"
        target="#helpButton"
        title="Tooltips"
        description="You can always find the button here if you need any help."
    />
  </el-tour>

  <!-- 3D network diagram shows the area -->
  <!-- test.json 前端是直接在这个文件里面进行画图的, 然后进行搜索工作是后端处理, 并且会复制一份test.json放在后端 -->
  <div v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="'Loading data... Please wait for a second...'" id="network-canvas" style="height: 100%;width: 100%;left: 0; margin: 0;padding: 0;overflow: hidden">
  </div>
</template>

<script setup>
//rePush
// 全局状态管理
import {
  myData,
  myGraph,
  state,
  selectedCategory,
  nodeRelativeCategoryMap,
  fullscreenLoading,
  handleNodeClick,
  navigateToNodeUrl,
  currentData, calcDistFromOrig, formData, lineOpacityCoef, labelFontScale
} from './stores/globalStore';
import { getLinkThreeObject, updateNodeRelativeCategory, getNodeThreeObject, isInView, initializeGraphData } from './stores/globalStore';

// 模块组件
import GraphTools from './components/GraphTools.vue';
import LegendPanel from './components/LegendPanel.vue';
import SearchDialog from './components/SearchDialog.vue';
import AboutDialog from './components/AboutDialog.vue';
// 自定义组件
import {onMounted, ref, watch} from "vue";
import {
  cameraFramePadding,
  centerNodeFontsize,
  graphConfig,
  initCameraAngle,
  labelConfig,
  minLinkLength
} from './configs/graphConfig';
import { Hide, View} from "@element-plus/icons-vue";

const openTour = ref(false);

const isHidden = ref(true);
const isHover = ref(false);

/**
 * Calculate the distance between two points
 */
// 5.5 计算两个点的距离
function calcDist(node1,node2){
  let distX=  node1.x-node2.x;
  let distY=  node1.y-node2.y;
  let distZ=  node1.z-node2.z;
  return Math.sqrt(distX*distX + distY*distY + distZ*distZ);
}

// 123

// 5.11 决定哪些节点是否该显示label标签

function calcThresholdOfNodeToShow(myGraph, ){
  // Calculate the minimum distance between the camera and all nodes in view;
  var camP = myGraph.cameraPosition();     // 获取相机位置
  const nodes = myGraph.graphData().nodes; // 获取所有节点

  let NodeDistArray = [];
  let minDistFromNodeToCam = Number.MAX_VALUE;
  // let selectedCategorySet = new Set(selectedCategory.value)

  // 收集节点信息
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if(isInView(myGraph, node)){ //  && selectedCategorySet.has(node.category)
      // Node is in view, calculate the distance to the camera;
      let distFromNodeToCam = calcDist(node,camP)
      node.dist = distFromNodeToCam;
      if(distFromNodeToCam < minDistFromNodeToCam){
        minDistFromNodeToCam = distFromNodeToCam;
      }
      NodeDistArray.push(node.size);
    }
  }

  // Descend Sorting
  NodeDistArray.sort(function(a,b){  return b-a;});
  // Get the number of nodes to display based on the closest distance and the distance from the camera to the origin when zooming to fit
  // 决定显示多少标签
  // 点标签
  let zoomScale = minDistFromNodeToCam/state.cameraOrigDist;
  let visibleNum = labelConfig.maxVisibleNum;
  if(zoomScale>=0.7){
    visibleNum = labelConfig.minVisibleNum;
  }else if(zoomScale<=0.2){
    visibleNum = labelConfig.maxVisibleNum
  }else{
    visibleNum = Math.round((zoomScale-0.20)*((labelConfig.minVisibleNum-labelConfig.maxVisibleNum)/0.5)+labelConfig.maxVisibleNum);
  }

  // Fix NodeDistArray[visibleNum] is undefined when num of nodes in View less than NodeDistArray.length
  if(visibleNum<NodeDistArray.length){
    return NodeDistArray[visibleNum]
  }else{
    return NodeDistArray[NodeDistArray.length - 1]
  }
}

// 7. 初始化3d图的代码, 初始所有节点都会显示
// 添加标志变量，确保二次渲染只执行一次
// let hasRenderedColorgroups = false;

onMounted( async()=>{
  try {
    // 异步加载数据, 如果要恢复文件获取, 把下面三行代码注释, 然后mydata去掉state
    // const response = await fetch('https://dev.parse-health.org/kage-api/keyword?keyword=PheCode:250.2');
    // const data = await response.json();
    // currentData.value = data.data;  // 把数据赋值给全局变量

    // console.log(data.data)

    currentData.value = myData

    console.log("数据获取成功");

    // Draw default Network, set default configurations
    var ele = document.getElementById("network-canvas"); // 获取画布容器
    nodeRelativeCategoryMap.value = updateNodeRelativeCategory(currentData.value) // 更新节点

    // 获取初始显示的数据
    const initialData = initializeGraphData(currentData.value);
    // 获取两套数据

    // 设置图的属性
    myGraph(ele)
      .graphData(initialData)  // 使用过滤后的数据
      .width(ele.offsetWidth)
      .height(ele.offsetHeight)
      .numDimensions(3)
      // .cameraPosition({ x: 0, y: 0, z: 350 }) // 相机视距
      .cameraPosition(initCameraAngle) // 相机视距
      .nodeVal(node=>{ // 根据节点连接数决定节点大小(视觉上的), 和节点的质量, 但由于使用了自定义3D对象, 所以只对结点力相关的计算产生影响, 质量越大越稳定
        return node.degree
      })
      .nodeThreeObjectExtend(false) // 去掉默认节点对象, 使用完全自定义3D对象
      .nodeThreeObject(node=>{  // 设置3d对象材质, 标签等
        return getNodeThreeObject(node, state.selectedIdSet, -1)
      })
      // 使用配置
      .enableNodeDrag(graphConfig.interaction.node.enableDrag)
      .backgroundColor(graphConfig.interaction.backgroundColor)
      .nodeLabel(graphConfig.interaction.node.tooltipFormat)
      .linkThreeObject(link=>{ // 把点连成线, 并且设置线的材质, 使用的是3d线条, 默认不需要写这个, 但线就会是2d的
        return getLinkThreeObject(link, 0.5, 0.05);
      })
      .linkLabel(graphConfig.interaction.link.tooltipFormat)
      .warmupTicks(30) // 在之前就开始反复调整画面节点布局, 让布局快速稳定且不混乱, 35是次数
      .cooldownTicks(100) // 快速停止引擎
      .onNodeClick((node) => handleNodeClick(node, myData))
      .onNodeRightClick(node => {
        // 右键点击节点时跳转到外部URL
        navigateToNodeUrl(node.id);
      })
      .onEngineStop(() => {
        updateLabelVisibility();
      })
      .d3Force('link')
        // 调整links长度, 通过设置最小links长度避免挤成一坨
        .distance(link => {
          if (link.length) {
            return link.length
          } else {
            const minLength = minLinkLength; // 设置最小链接长度
            const calculatedLength = 100 * (1 - Math.log(link.weight + 1) / Math.log(10));
            return Math.max(calculatedLength, minLength); // 返回计算长度和最小长度中的较大值
          }
        })


    setTimeout(()=>{

      // 进行标签显示初始化
      const nodes = myGraph.graphData().nodes;
      // const selectedCategorySet = new Set(selectedCategory.value);

      // 初次渲染时固定节点位置
      nodes.forEach(node => {
        node.fx = node.x;
        node.fy = node.y;
        node.fz = node.z;
      });

      myGraph.nodeVisibility(node => {
        return !(node.category === 'colorgroup');
      }).linkVisibility(link=> {
        return !(link.source.category === "colorgroup" || link.target.category === 'colorgroup');
      })

      setTimeout(()=>{
        myGraph.zoomToFit(10, cameraFramePadding);

        myGraph.linkThreeObject(link => {
          return getLinkThreeObject(link, formData.minThreshold, lineOpacityCoef.value/200);
        })

        let camera = myGraph.cameraPosition();
        state.cameraOrigDist = calcDistFromOrig(camera.x,camera.y,camera.z);

        myGraph.zoomToFit(600, cameraFramePadding, (node) => (node.category !== 'colorgroup'));

        updateLabelVisibility();

        let newToSystem = true;
        newToSystem = localStorage.getItem("first-used");

        if (!newToSystem) {
          openTour.value = true;
          localStorage.setItem("first-used", false);
        }
      },1005)
    },100)

    // 下面是对加载动画的操作, 以及标签的更新
    // Update Label visibility and end loading
    // setTimeout(()=>{
    //   myGraph.zoomToFit(600, cameraFramePadding, (node) => (node.category !== 'colorgroup'));
    //   updateLabelVisibility();
    // },500)

    // Listen for canvas updates and then update Label visibility
    if(document.getElementById("network-canvas")){
      var targetCanvasDom = ele.firstChild.firstChild.firstChild.childNodes[1]
      const callback = function (mutationsList,) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes') {
            state.labelNeedUpdateVisibility = 1;
            break;
          }
        }
      };

      // Observer configuration (what changes need to be observed)
      const config = { attributes: true, childList: true, subtree: true };
      const observer = new MutationObserver(callback);
      // Observer target base on above config
      observer.observe(targetCanvasDom, config);
    }

    // periodically check and exec updateLabelVisibility if state.labelNeedUpdateVisibility == 1
    setInterval(()=>{
      if (fullscreenLoading.value === true && state.labelNeedUpdateVisibility===1) {
        myGraph.zoomToFit(10, cameraFramePadding);
        setTimeout(() => {
          updateLabelVisibility();
          setTimeout(fullscreenLoading.value = false, 100)
        }, 15)
        state.labelNeedUpdateVisibility = 0;
      } else if(state.labelNeedUpdateVisibility===1 && fullscreenLoading.value === false) {
        console.log("updateVisibility");
        updateLabelVisibility();
        state.labelNeedUpdateVisibility = 0;
      }
    },1000)
  } catch (error) {
    console.error('初始化失败:', error);
  }
})

/***
 *  update visibility of nodes, links, labels once selectedCategory changes
 */
// 监听右侧复选框, 然后显示或隐藏节点和连线
watch(selectedCategory, ()=>{
  let originalCategorySet = new Set(selectedCategory.value)
  let selectedCategorySet = new Set(selectedCategory.value)
  let tmpRelSet = new Set()
  let leftSelectedRelCategorySet = new Set()

  selectedCategorySet = selectedCategorySet.union(state.selectedCategoriesSet)

  console.log(selectedCategorySet)

  myGraph.nodeVisibility((node)=>{

    // 中心节点始终显示（不受右侧legend影响）
    if (state.selectedIdSet.has(node.id)) {
      node.hidden = false;
      return true;
    }

    // If all the links of a nodes are invisible <==> the categories of all the nodes connected to this node are not in the selectedCategorySet
    // console.log(nodeRelativeCategoryMap.value)
    tmpRelSet = nodeRelativeCategoryMap.value.get(node.id)
    // console.log(tmpRelSet)
    leftSelectedRelCategorySet = [...tmpRelSet].filter(id => originalCategorySet.has(id))
    console.log(originalCategorySet)
    if (originalCategorySet.has(node.category) && leftSelectedRelCategorySet.length>0) {
      node.hidden = false;
      return true;
    } else {
      node.hidden = true;
      return false;
    }
  }).linkVisibility((link)=>{
    return selectedCategorySet.has(link.source.category) && selectedCategorySet.has(link.target.category) && (!link.target.hidden) && (!link.source.hidden)
  })
  updateLabelVisibility()
},{deep:true})


/**
 * Update ThreeObject Control Label display and close
 */
// 更新节点标签的显示
let enableDynamicLabels = true; // 设置为 false 来屏蔽动态显示功能
// 动态计算标签字体大小
function calculateLabelFontSize(node, camera) {
  // 设置字体大小的范围
  const MIN_FONT_SIZE = labelConfig.minFontSize;
  const MAX_FONT_SIZE = labelConfig.maxFontSize;
  const MAX_DISTANCE = 500; // 最大参考距离

  // 计算节点到相机的距离
  const distance = calcDist(node, camera);

  // 使用指数衰减函数计算字体大小
  // 当距离为0时得到最大字体，距离增加时字体大小呈指数衰减
  const scale = Math.exp(-distance / MAX_DISTANCE);
  const fontSize = MIN_FONT_SIZE + (MAX_FONT_SIZE - MIN_FONT_SIZE) * scale;

  // 确保字体大小在允许范围内
  return Math.max(MIN_FONT_SIZE, Math.min(fontSize, MAX_FONT_SIZE)) * labelFontScale.value;
}

// 修改updateLabelVisibility函数
function updateLabelVisibility(){
  if (!enableDynamicLabels) {
    console.log("Dynamic label display is currently disabled.");
    return;
  }

  const camera = myGraph.cameraPosition();
  const nodes = myGraph.graphData().nodes;
  const selectedCategorySet = new Set(selectedCategory.value);

  nodes.forEach(node => {
    if (node.nodeLabel && node.nodeLabel.element &&
        isInView(myGraph, node) &&
        selectedCategorySet.has(node.category)) {
      // 计算并更新字体大小
      if ( state.selectedIdSet.has(node.id)) {
        node.nodeLabel.element.style.fontSize = `${centerNodeFontsize}rem`;
        node.nodeLabel.element.style.color = `#39b5f4`;
      } else {
        const fontSize = calculateLabelFontSize(node, camera);
        node.nodeLabel.element.style.fontSize = `${fontSize}rem`;
      }
    }
  });

  let VisThreshold = calcThresholdOfNodeToShow(myGraph);

  // 更新节点的显示状态
  myGraph.nodeThreeObject(node => {
    return getNodeThreeObject(node, state.selectedIdSet, VisThreshold);
  });
}

</script>

<style>

.help-btn {
  /* 隐藏时位移到屏幕外 */
  transform: translateX(-200px);
  transition: transform 0.3s ease;
}

.help-btn.show {
  transform: translateX(0);
}

.hidden-handler {
  position: fixed;
  top: 0.7rem;
  right: 5.667rem;

  background: linear-gradient(90deg, rgba(24, 25, 26, 0.95), rgba(46, 46, 47, 0.95));
  backdrop-filter: blur(1px);
  border: 1px solid rgba(255, 255, 255, 0.1);

  box-shadow: -0.267rem 0 1.067rem rgba(0, 0, 0, 0.3);
  border-right: none;
  border-bottom: none;

  border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
  width: 1.867rem;
  height: 1.867rem;
  z-index: 2001;
  transform: translateX(5.33rem);
  transition: transform 0.3s ease;
}

.hidden-handler.show {
  transform: translateX(0);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  margin: 0;
  padding: 0;
}

.tooltip {
  z-index: 1000;
  color: rgba(0,0,0,0.9);
  font-size: 14px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  padding: 7px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.3);
  text-align: left;
}
.nodelabel{
  z-index: 0;
  font-size: 11px;
  color: rgb(255,255,255);
  padding: 1px 4px;
  border-radius: 4px;
  /* line-height: 12px; */
  /* background-color: rgba(0, 0, 0, 0.5); */
  opacity: 70%;
  -webkit-text-stroke: 0.04px yellow;
  font-weight: 600;
  user-select: none;
}
/* label标红 */
.nodehighlight{
  z-index: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  text-shadow: 0 0 5px grey;
  color: rgba(255,255,255,0.95);
  padding: 1px 4px;
  border-radius: 4px;
  background-color: rgba(242, 12, 81, 0.7);
  user-select: none;
}
.scene-tooltip {
  z-index: 9000;
  color: rgba(255, 255, 255, 0.95);
  line-height: 0.667rem;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 0.133rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  text-align: left;
  pointer-events: none;
  position: absolute;
  white-space: nowrap;
  transform: translate(-50%, -100%);
  margin-top: -0.267rem;
  user-select: none;
}
</style>

